<template>
    <aside id="Sidebar">

        <!-- Image -->
        <div class="container">
            <div class="row">
                <div class="col-12 pt-3 py-2">
                    <img width="90" height="90" :src="wiks_logo" alt=""> <br>
                </div>
            </div>
        </div>

        <!-- Menu -->
        <div id="sidebar-content" class="sidebar-content flex-between flex-column h-100">
            <div id="sidebar-content-menu" class="container-fluid">

                <div @click.stop="!item.submenu ? redirect(item.route) : item.open = true" 
                    @mouseenter="item.open = true"
                    @mouseleave="item.open = false"
                    class="row item-menu py-0 py-2" 
                    v-for="(item, index) in menu" :key="`menu-${index}`">

                        <div class="col-12 flex-center border-right mb-1 p-0">
                            <div :class="`flex-center circle ${ active.menu === item.label ? 'active' : '' }`">
                                <img :src="item.icon" alt="" width="28" height="28" class="rounded">
                            </div>
                        </div>
                        <div class="flex-center px-3">
                            <span :class="`description-xs ${ active.menu === item.label ? 'opensans-semibold text-primary' : '' }`">
                                {{ item.label }}
                            </span>
                        </div>

                        <!-- Submenu -->
                        <div class="submenu_wrapper"
                            @mouseleave="item.open = false"
                            v-if="item.open && item.submenu">

                            <div class="submenu_content">
                                <template v-for="(option, index) in item.submenu" :key="`submenu-${index}`">
                                    <button @click.stop="redirect(option.route, option.params); item.open = false;"
                                        class="submenu_btn"
                                        :class="`${ active.menu === item.label && option.label === active.submenu ? 'submenu_btn_active' : '' }`"
                                        type="button">
                                        <span :class="`${ active.menu === item.label && option.label === active.submenu ? 'text-primary' : '' }`">
                                            {{ option.label }}    
                                        </span>
                                    </button>
                                </template>
                            </div>

                        </div>
                </div>
            </div>

            <div class="item-logout w-100 ">
                <button @click.stop="endsession" class="btn w-100 flex-center flex-column">
                    <div :class="`flex-center circle`">
                        <img :src="reply_big" alt="" width="28" height="28" class="rounded">
                    </div>

                    <span>
                        Cerrar sesión
                    </span>
                </button>
            </div>
        </div>
    </aside>
</template>

<script setup>
    import { ref, inject, computed, onMounted } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter, useRoute } from 'vue-router';

    // Images
    const wiks_logo = require('ASSETS/images/wiks_logo');

    // Icons
    import heishop from 'ASSETS/icons/sidebar/heishop_bn'
    import list from 'ASSETS/icons/sidebar/list'
    import fridge from 'ASSETS/icons/sidebar/fridge'
    import globe from 'ASSETS/icons/sidebar/globe'
    import medal_star_alt from 'ASSETS/icons/sidebar/medal_star_alt'
    import file_report from 'ASSETS/icons/sidebar/file_report'
    import spanner from 'ASSETS/icons/sidebar/spanner'
    import user from 'ASSETS/icons/sidebar/user'
    import reply_big from 'ASSETS/icons/sidebar/reply_big'


    // Hooks
    const store = useStore();
    const router = useRouter();
    const route = useRoute(); // Obtiene la ruta actual

    // Injects
    const redirect = inject('$redirect')

    // Computed 
    const current_router_name = computed(() => {
        return router.currentRoute.value.name
    })

    const active = computed(() => {
        // => console.log(current_router_name.value, 'current_router_name.value')
        for(let item of menu.value) {
            if(item.submenu !== undefined && item.submenu !== null) {
                for(let submenu of item.submenu) {
                    // => console.log(submenu.route, 'submenu.route')
                    if(submenu.route === current_router_name.value) {
                        return {
                            menu: item.label,
                            submenu: submenu.label
                        }
                    }
                }
            }
            else {
                // => console.log(item.route, 'item.route')
                if(item.route === current_router_name.value) {
                    return {
                        menu: item.label,
                        submenu: null
                    }
                }
            }
        }
        return {
            menu: null,
            submenu: null
        }
    })

    // Variables
    const menu = ref([
        {
            label: 'HeiShop',
            route: 'heishop',
            section: 'heishop',
            icon: heishop,
            open: false,
            submenu: [
                { label: 'Clientes', route: 'heishop-clients' },
                { label: 'Productos', route: 'heishop-products' },
                { label: 'Inventarios', route: 'heishop-inventarios' },
                { label: 'CPL', route: 'heishop-cpl' },
                { label: 'Precios', route: 'heishop-precios' },
                { label: 'Bonificaciones', route: 'heishop-bonificaciones' },
                { label: 'Targets', route: 'heishop-target' },
                { label: 'Promociones', route: 'heishop-promociones' },
                { label: 'Monitoreo', route: 'heishop-monitoreo' }

            ]
        },
        // {
        //     label: 'Encuestas',
        //     route: 'surveys',
        //     section: 'supervision',
        //     icon: list,
        //     open: false,
        //     submenu: [
        //         { label: 'Encuestas', route: 'surveys' },
        //         { label: 'Preguntas', route: 'questions' },
        //         { label: 'Respuestas', route: 'answers' },
        //     ]
        // },
        // {
        //     label: 'Refrigeracion',
        //     route: 'refrigeration',
        //     section: 'supervision',
        //     icon: fridge,
        //     open: false,
        //     submenu: [
        //         { label: 'Refrigeracion', route: 'refrigeration' },
        //         { label: 'Analisis IA', route: 'ia-analysis' },
        //     ]
        // },
        // {
        //     label: 'Conquista',
        //     route: 'conquest',
        //     section: 'conquest',
        //     icon: globe,
        //     open: false,
        //     submenu: [
        //         { label: 'Conquista', route: 'conquest' },
        //         { label: 'Geolocalizacion', route: 'geolocation' },
        //     ]
        // },
        {
            label: 'Puntos Wiks',
            route: 'banners',
            section: 'lealtad',
            icon: medal_star_alt,
            open: false,
            submenu: [
                { label: 'Canjes', route: 'points-redeems' },
                { label: 'Categorias', route: 'points-categories' },
                { label: 'Niveles', route: 'points-settings' },
                { label: 'Productos', route: 'points-products' }
            ]
        },
        {
            label: 'Reportes',
            icon: file_report,
            section: 'reports',
            open: false,
            submenu: [
                { label: 'Ventas', route: 'sales' },
                { label: 'Tajertas', route: 'card-sales' },
                { label: 'Clientes', route: 'clients-report' },
                { label: 'Productos', route: 'products-report' },
                { label: 'Colonias', route: 'neighborhood' },
                { label: 'Municipios', route: 'locations' },
                { label: 'Redenciones', route: 'points-report' }
            ]
        },
        {
            label: 'Configuración',
            icon: spanner,
            section: 'configuration',
            open: false,
            submenu: [
                { label: 'Banners', route: 'banners' },
                { label: 'Categorías', route: 'categories' },
                { label: 'Costos de envío', route: 'shipment-cost' },
                { label: 'Familias', route: 'families' },
                { label: 'Productos', route: 'products' },
                { label: 'Mensajes notificación', route: 'notifications' },
                { label: 'Nuevos productos', route: 'raw-products' }
            ]
        },
        {
            label: 'Usuarios',
            icon: user,
            section: 'clients',
            submenu: [
                { label: 'Clientes', route: 'registered' },
                { label: 'Preventa', route: 'presale' },
                { label: 'Reparto', route: 'assortment' },
                { label: 'Sin registro', route: 'unregistered' }
            ]
        }
    ]);

    const section = computed(() => store.getters['getSection']);

    // Método para verificar si el menú está activo
    const isActive = (menu) => {
        if (menu.route === route.name) return true;
        return menu.submenu && menu.submenu.some(submenu => submenu.route === route.name);
    };

    // Método para cerrar sesión
    const endsession = () => {
        sessionStorage.removeItem('wiks@session');
        window.location.reload();
    };

    // Vue CycleLife
    window.addEventListener('resize', function() {
        try {
            let w_screen = window.innerWidth
            let h_screen = window.innerHeight
            console.log(h_screen, 'h_screen')

            if(h_screen < 500) {
                let sidebar_content = document.getElementById("sidebar-content-menu")
                console.log(sidebar_content, 'sidebar-content')
                if(!sidebar_content) return

                // sidebar_content.style.height = `200px`
                // sidebar_content.style.overflowY = 'scroll'
                // sidebar_content.style.overflowX = 'visible'

                
                // let submenu = document.getElementsByClassName("submenu_wrapper")
                // for(let i = 0; i < submenu.length; i++) {
                //     let item = submenu[i]
                //     console.log(item.style.left, 'left')
                //     item.style.left = "-90px";
                // }
            }
            else {
                // sidebar_content.style.height = `100%`
                // sidebar_content.style.overflowY = 'auto'


                // let submenu = document.getElementsByClassName("submenu_wrapper")
                // for(let i = 0; i < submenu.length; i++) {
                //     let item = submenu[i]

                //     item.style.left = "-90px";
                // }
            }
        }
        catch(err) {
            console.log(err)
        }
    })

    function triggerResize() {
        const event = new Event('resize');
        window.dispatchEvent(event);
    }

    onMounted(() => {
        triggerResize()

        setTimeout(function() {
            triggerResize()
        }, 100);
    })

</script>

<style lang="scss" scoped>
    @import '../assets/scss/minxin.scss';

    #Sidebar {
        height: 100dvh;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        color: var(--bs-secondary);
        background-color: var(--bs-light-gray);
        width: 130px;
        position: relative;
        z-index: 2;

        // .custom_height {
        //     overflow-y: scroll;
        //     height: 430px;

        //     @media screen and (min-width: 1440px) {
        //         height: 70vh;
        //     }
        // }

        .circle {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            transition: all 0.5s;
        }
        .active {
            background: white;
        }


        .sidebar-content {


            .item-menu {
                position: relative;
                cursor: pointer;

                &:hover {
                    background-color: #97979780;
                }

                &:hover .circle {
                    background: white;
                }

                .submenu_wrapper {
                    background-color: black;
                    position: absolute;
                    top: 0;
                    left: 130px;
                    padding: 0px;
                    z-index: 10;

                    // right: 0px;
                    // left: 0px;
                    // bottom: 0px;

                    .submenu_content {
                        background-color: var(--bs-dark-gray);
                        width: 220px !important;
                        padding: 10px 10px;

                        display: flex;
                        flex-direction: column;

                        box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
                        border: 2px solid black;
                        z-index: 100;

                        .submenu_btn {
                            background-color: var(--bs-dark-gray);
                            color: var(--bs-white);
                            border: none;
                            border-bottom: 1px solid grey;
                            
                            width: 200px !important;
                            transition: all 0.8s;

                            padding: 10px 0px;


                            // First and Last item
                            &:first-of-type {
                                border-top: 1px solid grey;
                            }

                            &:last-of-type {

                            }

                            // Hover
                            &:hover {
                                background-color: color-mix(in srgb, var(--bs-primary), black 30%);
                                color: var(--bs-white);
                            }
                        }

                        .submenu_btn_active {
                            background-color: var(--bs-light) !important;
                            font-family: OpenSans-SemiBold;
                        }
                    }
                }
            }
        }

        .item-logout {
            &:hover {
                background-color: #97979780;
                color: white;
            }

            &:hover .circle {
                background: white;
            }
        }
    }
</style>